var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    { class: { scrolled: _vm.scrollPosition > 20 } },
    [
      _c(
        "b-navbar",
        { attrs: { toggleable: "md", type: "light" } },
        [
          _c("b-navbar-toggle", { attrs: { target: "nav_collapse" } }),
          _vm._v(" "),
          _c("b-navbar-brand", { attrs: { href: "#" } }, [
            _c(
              "h1",
              [
                _c("router-link", { attrs: { alt: "Click2Giv", to: "/" } }, [
                  _c("img", { staticClass: "logo", attrs: { src: _vm.logo } })
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "social-media" }, [
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.instagram.com/click2giv/",
                  target: "_blank"
                }
              },
              [
                _c("font-awesome-icon", {
                  staticClass: "icon",
                  attrs: { icon: ["fab", "instagram"], size: "lg" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.facebook.com/click2giv",
                  target: "_blank"
                }
              },
              [
                _c("font-awesome-icon", {
                  staticClass: "icon",
                  attrs: { icon: ["fab", "facebook"], size: "lg" }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "b-collapse",
            { attrs: { "is-nav": "", id: "nav_collapse" } },
            [
              _c(
                "b-navbar-nav",
                { staticClass: "ml-auto" },
                [
                  _c("b-nav-form", [
                    _c(
                      "form",
                      { staticClass: "d-md-block form-inline ml-auto search" },
                      [
                        _c("font-awesome-icon", {
                          staticClass: "icon",
                          attrs: { icon: ["fas", "search"], size: "lg" }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.searchText,
                              expression: "searchText"
                            }
                          ],
                          staticClass: "form-control mr-sm-2",
                          attrs: {
                            type: "text",
                            placeholder: "Buscar Projeto",
                            "aria-label": "Search"
                          },
                          domProps: { value: _vm.searchText },
                          on: {
                            keyup: function($event) {
                              return _vm.searchProject()
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.searchText = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "searchloading" },
                          [
                            _vm.searchLoading
                              ? _c("font-awesome-icon", {
                                  staticClass: "icon fa-spin",
                                  attrs: { icon: ["fas", "spinner"] }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        !_vm.searchLoading && _vm.isSearching
                          ? _c(
                              "a",
                              {
                                staticClass: "clearsearch",
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    $event.preventDefault()
                                    return _vm.clearSearch()
                                  }
                                }
                              },
                              [
                                _c("font-awesome-icon", {
                                  staticClass: "icon",
                                  attrs: {
                                    icon: ["fas", "times-circle"],
                                    size: "lg"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.resultProjects
                          ? _c("div", { staticClass: "result" }, [
                              _c(
                                "ul",
                                _vm._l(_vm.resultProjects, function(p) {
                                  return _c("li", { key: p.ProjectId }, [
                                    p.Info.image
                                      ? _c("img", {
                                          attrs: { src: p.Info.image },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              $event.preventDefault()
                                              return _vm.openProject(p.slug)
                                            }
                                          }
                                        })
                                      : _c("img", {
                                          attrs: {
                                            src:
                                              "https://via.placeholder.com/100x100?text=Sem+Foto"
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              $event.preventDefault()
                                              return _vm.openProject(p.slug)
                                            }
                                          }
                                        }),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        attrs: { href: "#" },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            $event.preventDefault()
                                            return _vm.openProject(p.slug)
                                          }
                                        }
                                      },
                                      [_vm._v(_vm._s(p.Info.title))]
                                    )
                                  ])
                                }),
                                0
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "navbar-nav" },
                    [
                      !_vm.isAuth
                        ? _c(
                            "b-nav-item-dropdown",
                            { attrs: { left: "" } },
                            [
                              _c("template", { slot: "button-content" }, [
                                _c("a", { attrs: { href: "" } }, [
                                  _vm._v("Cadastre-se")
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-dropdown-item",
                                { attrs: { href: "/signup-ong" } },
                                [_vm._v("Cadastre-se como ONG")]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-dropdown-item",
                                { attrs: { href: "/signup" } },
                                [_vm._v("Cadastre-se como Usuário")]
                              )
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "li",
                        { staticClass: "nav-item active" },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "nav-link",
                              attrs: { to: "/projects" }
                            },
                            [_vm._v("ONGs")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-nav-item-dropdown",
                        { attrs: { left: "" } },
                        [
                          _c("template", { slot: "button-content" }, [
                            _c("a", { attrs: { href: "" } }, [
                              _vm._v("Descontos do Bem")
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-dropdown-item",
                            {
                              attrs: {
                                href: "/descontosdobem?section=products"
                              }
                            },
                            [_vm._v("Produtos em Destaque")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-dropdown-item",
                            {
                              attrs: { href: "/descontosdobem?section=stores" }
                            },
                            [_vm._v("Lojas com Ofertas")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-dropdown-item",
                            {
                              attrs: {
                                href: "/descontosdobem?section=discounts"
                              }
                            },
                            [_vm._v("Cupons e Descontos")]
                          )
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        { staticClass: "nav-item active" },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "nav-link",
                              attrs: { to: "/about" }
                            },
                            [_vm._v("Sobre")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.isAuth
                        ? _c(
                            "li",
                            { staticClass: "nav-item active" },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "nav-link",
                                  attrs: { to: "/login" }
                                },
                                [_vm._v("Entrar")]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isAuth
                        ? _c(
                            "b-nav-item-dropdown",
                            { attrs: { right: "" } },
                            [
                              _c("template", { slot: "button-content" }, [
                                _c(
                                  "a",
                                  { attrs: { href: "" } },
                                  [
                                    _vm._v("Perfil "),
                                    _vm.countUnreadNotifications > 0
                                      ? _c("b-badge", [
                                          _vm._v(
                                            _vm._s(_vm.countUnreadNotifications)
                                          )
                                        ])
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-dropdown-item",
                                { attrs: { href: "/dashboard" } },
                                [_vm._v("Dashboard")]
                              ),
                              _vm._v(" "),
                              _vm.user && _vm.user.profile == "ong"
                                ? _c(
                                    "b-dropdown-item",
                                    { attrs: { href: "/profile/my-projects" } },
                                    [_vm._v("Meus Projetos")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.user && _vm.user.profile != "ong"
                                ? _c(
                                    "b-dropdown-item",
                                    {
                                      attrs: { href: "/profile/my-donations" }
                                    },
                                    [_vm._v("Minhas Doações")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "b-dropdown-item",
                                { attrs: { href: "/profile" } },
                                [_vm._v("Meu Perfil")]
                              ),
                              _vm._v(" "),
                              _vm.user && _vm.user.isPartner
                                ? _c(
                                    "b-dropdown-item",
                                    {
                                      attrs: { href: "/profile?tab=campaigns" }
                                    },
                                    [_vm._v("Campanhas")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "dropdown-divider" }),
                              _vm._v(" "),
                              _c(
                                "b-dropdown-item",
                                { attrs: { href: "/notifications" } },
                                [
                                  _vm._v("Notificações "),
                                  _vm.countUnreadNotifications > 0
                                    ? _c("b-badge", [
                                        _vm._v(
                                          _vm._s(_vm.countUnreadNotifications)
                                        )
                                      ])
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "dropdown-divider" }),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  attrs: { href: "#" },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      $event.preventDefault()
                                      return _vm.logout()
                                    }
                                  }
                                },
                                [_vm._v("Sair")]
                              )
                            ],
                            2
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-142c33de", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-142c33de","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/includes/Header.vue
// module id = null
// module chunks = 